import styled from 'styled-components';
import { Modal } from 'antd';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import { Form } from '@/components';

export const StyledModal = styled(Modal)``;

export const StyledWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: space-between;
`;

export const StyledActionButton = styled(Button)`
  &&& {
    max-width: 8rem;
    height: 3rem;
    ${pickThemeFontStyles('14', '18', 'SEMI_BOLD')};
    align-items: center;
  }
`;

export const StyledMessage = styled.div`
  ${pickThemeFontStyles('16', '18', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('20', '26', 'SEMI_BOLD')};
  color: ${COLORS.GREY_DARK};
`;

export const StyledForm = styled(Form)`
  gap: 1rem;
  display: flex;
  flex-direction: column;
`;
